// removed by extract-text-webpack-plugin
module.exports = {"nf-pdmi-credentials":"nf-pdmi-credentials","nf-pdmi-credentials__header":"nf-pdmi-credentials__header"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PdmiCredentials/PdmiCredentials.scss
// module id = 5564
// module chunks = 1